import axios from "axios";
import { Base_Api } from "../config";
const axiosInstance = axios.create({
  baseURL: Base_Api,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accesstoken")
    console.log("Request Interceptor:", config);
    return {
      ...config,
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined
      }
    };
  },

  (error) => {
    console.error("Request Interceptor Error:", error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || "Something Went Wrong"
    )
);
export default axiosInstance;


